import { Image, SimpleGrid } from '@chakra-ui/react';

import { AdminPaymentProofDisplayItem } from '../../types/payment-proof-ocr';
import { PaymentProofOcrCard } from './payment-proof-ocr-card';

interface PaymentProofDisplayGridProps {
  items: AdminPaymentProofDisplayItem[];
}

export function PaymentProofDisplayGrid({
  items,
}: PaymentProofDisplayGridProps) {
  return (
    <SimpleGrid
      data-testid="payment-proof-display-grid"
      columns={{ base: 1, xl: 2 }}
      columnGap={8}
      rowGap={{ base: 10, xl: 16 }}
      alignItems="flex-start"
    >
      {items.map((displayItem, index) => {
        if (displayItem.kind === 'ocr') {
          return (
            <PaymentProofOcrCard
              key={displayItem.item.id}
              item={displayItem.item}
            />
          );
        }

        return (
          <Image
            key={displayItem.id}
            src={displayItem.url}
            alt={`Bukti Pembayaran-${index}`}
            data-testid="payment-proof-legacy-preview"
            w="100%"
            border="1px solid"
            borderColor="#E2E8F0"
            borderRadius="8px"
            objectFit="contain"
            bg="white"
            loading="lazy"
          />
        );
      })}
    </SimpleGrid>
  );
}
